export const DayMonthYear = (params) => {

    const date = new Date(params);
    const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };

    return date.toLocaleDateString('en-GB', optionsDate);
};

export const DayMonthYearWithTime = (params) => {

    const date = new Date(params);
    const optionsDate = { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'UTC' };

    return date.toLocaleString('en-GB', optionsDate);
}

export const OnlyTime = (params) => {

    const date = new Date(params);
    const optionsDate = { hour: '2-digit', minute: '2-digit', hour12: true, timeZone: 'UTC' };

    return date.toLocaleString('en-GB', optionsDate);
}

export const YYYYMMDD = (params) => {
    const date = new Date(params);

    let year = date.getUTCFullYear();
    let month = String(date.getUTCMonth() + 1).padStart(2, '0');
    let day = String(date.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const get_date_value = () => {
    var currentDate = new Date();

    // Subtract 16 years from the current date
    var previous16YearsDate = new Date(currentDate);
    previous16YearsDate.setFullYear(currentDate.getFullYear() - 16);

    // Format the date as yyyy-mm-dd
    var formattedDate = previous16YearsDate.toISOString().split("T")[0];
    return formattedDate;
};

export const HideOldDateFromToday = () => {
    let currentDate = new Date();

    let newDate = new Date(currentDate);
    newDate.setFullYear(currentDate.getFullYear());

    // Format the date as yyyy-mm-dd
    var formattedDate = newDate.toISOString().split("T")[0];
    return formattedDate;
};

export const deepSearch = (data, searchText) => {
    const searchLower = searchText?.toLowerCase();

    const deepSearchObject = (obj) => {
        if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(value => deepSearchObject(value));
        }
        if (Array.isArray(obj)) {
            return obj.some(value => deepSearchObject(value));
        }
        if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
            return obj.toString().toLowerCase().includes(searchLower);
        }
        return false;
    };

    return data && data?.filter(item => deepSearchObject(item));
};

export const DeepSearchSpace = (data, searchText) => {
    const normalizeText = (text) => text?.toLowerCase().replace(/\s+/g, '');

    const searchLower = normalizeText(searchText);

    const deepSearchObject = (obj) => {
        if (typeof obj === 'object' && obj !== null) {
            return Object.values(obj).some(value => deepSearchObject(value));
        }
        if (Array.isArray(obj)) {
            return obj.some(value => deepSearchObject(value));
        }
        if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
            return normalizeText(obj.toString()).includes(searchLower);
        }
        return false;
    };

    if (!Array.isArray(data)) {
        console.warn("DeepSearchSpace expected an array, but got:", typeof data, data);
        return [];
    }

    return data.filter(item => deepSearchObject(item));
};


export const DataTableCustomStyles = {
    cells: {
        style: { textAlign: "center", color: "rgba(0, 0, 0, 0.6)", whiteSpace: "nowrap", fontFamily: 'Philosopher', width: "150px" },
    },
    rows: {
        style: { minHeight: '65px', backgroundColor: "#fff", fontFamily: 'Philosopher' },
    },
    headRow: {
        style: { whiteSpace: 'nowrap', fontSize: "14px", fontWeight: "600", color: "#667284", backgroundColor: '#E2E8F0', fontFamily: 'Philosopher' }
    }
};

export const secondsToHMS = (duration) => {
    const seconds = parseFloat(duration).toFixed(0)
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

//! Common Function 
export const IndianRupee = (rupee) => {

    let Rupee = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
    });

    return `${Rupee.format(rupee)}/-`
};